import translationHome from "./translationHome";

const translations = {
  home: translationHome,
};

export default translations;
